import locale from 'antd/es/locale/de_DE';

locale.Pagination.items_per_page = ' Ergebnisse';

export default locale;
